import { render } from "./basicModal.vue?vue&type=template&id=5b73696b&lang=true"
import script from "./basicModal.vue?vue&type=script&lang=js"
export * from "./basicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__